import qs from 'query-string';
import { getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    createFormative: (body) => postRequest(`/formatives`, body),
    listFormatives: (filter, orderBy, skip, top, options = {}) => {
        const query = qs.stringify(
            { $filter: filter, $orderBy: orderBy, $skip: skip, $top: top },
            { skipNull: true, skipEmptyString: true }
        );
        return getRequest(`/formatives?${query}`, options);
    },
    updateFormative: (id, body) => patchRequest(`/formatives/${id}`, body),
};

export default services;
